import { playerStore } from "../../../../store/player.store"
import { observer } from "mobx-react"
import * as THREE from "three"
import { useEffect, useRef, useState } from "react"
import { useFrame, useThree } from "@react-three/fiber"
import bellAudio from "../../../../assets/audio/bell.mp3"
import helloAudio from "../../../../assets/audio/hello-voice.mp3"
import assistAudio from "../../../../assets/audio/assist-voice.mp3"
import buyAudio from "../../../../assets/audio/buy-voice.mp3"
import formAudio from "../../../../assets/audio/form-voice.mp3"
import formSuccessAudio from "../../../../assets/audio/form-success.mp3"
import formFinishAudio from "../../../../assets/audio/form-finish-voice.mp3"
import { toast } from "react-toastify"
import { PointerLockControls } from "@react-three/drei"

const StartRobot = observer(({ model }) => {
    const bellRef = useRef()
    const mixerRef = useRef(null)
    const keyPressListenerRef = useRef(null)
    const [bellVoice] = useState(new Audio(bellAudio))
    const [helloVoice] = useState(new Audio(helloAudio))
    const [assistVoice] = useState(new Audio(assistAudio))
    const [buyVoice] = useState(new Audio(buyAudio))
    const [formVoice] = useState(new Audio(formAudio))
    const [formFinishVoice] = useState(new Audio(formFinishAudio))
    const [formSuccessVoice] = useState(new Audio(formSuccessAudio))
    const pointerLockRef = useRef()
    const [isFirstTimeCallBot, setIsFirstTimeCallBot] = useState(true)
    const { camera } = useThree()

    useFrame((_, delta) => {
      if (mixerRef.current) {
        mixerRef.current.update(delta) // Оновлення анімації
      }
    })

    useEffect(() => {
      if (model) {
        mixerRef.current = new THREE.AnimationMixer(model.nodes["robot"])
      }

      return () => {
        if (mixerRef.current) {
          mixerRef.current.stopAllAction()
          mixerRef.current = null
        }
      }
    }, [model])

  const checkDistance = (objectPosition) => {
    // Отримуємо позицію камери
    const cameraPosition = new THREE.Vector3();
    camera.getWorldPosition(cameraPosition);

    // Використовуємо передану позицію об'єкта
    const objectPositionVec = new THREE.Vector3(...objectPosition); // розпаковуємо масив координат

    // Обчислюємо відстань між камерою та об'єктом
    const distance = cameraPosition.distanceTo(objectPositionVec);

    // Перевірка: якщо відстань менше або дорівнює 1 метру
    return distance <= 2;
  };

  const checkIsPlayerGoOut = () => {
    // Отримуємо позицію камери
    const cameraPosition = new THREE.Vector3();
    camera.getWorldPosition(cameraPosition);

    // Використовуємо передану позицію об'єкта
    const objectPositionVec = new THREE.Vector3(-0.92,1.4,0); // розпаковуємо масив координат

    // Обчислюємо відстань між камерою та об'єктом
    const distance = cameraPosition.distanceTo(objectPositionVec);

    // Перевірка: якщо відстань менше або дорівнює 1 метру
    return distance >= 3;
  };

    const startRobotAnimation = () => {
      if (!checkDistance([-0.92,1.4,-0.97])) return
      if (playerStore.isRobotActive) return

      mixerRef.current.stopAllAction()
      bellVoice.currentTime = 0
      bellVoice.play()

      playerStore.showRobot()

      if (mixerRef.current && model.animations) {
        const clip = THREE.AnimationClip.findByName(model.animations, "robot_fly")
        const clipIdle = THREE.AnimationClip.findByName(model.animations, "robot_wait") // Анімація після завершення

        const action = mixerRef.current.clipAction(clip)
        action.reset()
        action.setLoop(THREE.LoopOnce)
        action.clampWhenFinished = true
        action.play()

        const robotComeToPlayer = (e) => {
          if (e.action === action) {
            if (playerStore.isBlankInPlayer) {
              formFinishVoice.currentTime = 0
              formFinishVoice.play()
              setTimeout(() => {
                setActiveSubmitsHandler()
              }, 3000)
            } else if (isFirstTimeCallBot) {
              helloVoice.currentTime = 0
              helloVoice.play()
              setIsFirstTimeCallBot(false)
              setTimeout(() => {
                setActiveSubmitsHandler()
              }, 3000)
            } else {
              assistVoice.currentTime = 0
              assistVoice.play()
              setTimeout(() => {
                setActiveSubmitsHandler()
              }, 1500)
            }
          }

          const actionIdle = mixerRef.current.clipAction(clipIdle)

          actionIdle.reset()
          actionIdle.setLoop(THREE.LoopRepeat, Infinity) // Нескінченне повторення для idle анімації
          actionIdle.play()
          mixerRef.current.removeEventListener("finished", robotComeToPlayer)
        }

        mixerRef.current.addEventListener("finished", robotComeToPlayer)


      }
    }

    const robotGoOut = (timeOut) => {
      playerStore.clearActiveSubmits()
      window.removeEventListener("keydown", keyPressListenerRef.current)
      setTimeout(() => {
        keyPressListenerRef.current = null
        mixerRef.current.stopAllAction()
        const clipBack = THREE.AnimationClip.findByName(model.animations, "robot_back")
        const action = mixerRef.current.clipAction(clipBack)
        action.reset()
        action.setLoop(THREE.LoopOnce)
        action.clampWhenFinished = true
        action.play()
        setTimeout(() => {
          playerStore.hideRobot()
        }, 3000)
      }, timeOut)
    }

    const setActiveSubmitsHandler = () => {

      const interval = setInterval(() => {
        const isPlayerGoOut = checkIsPlayerGoOut();

        if (isPlayerGoOut) {
          buyVoice.currentTime = 0
          buyVoice.play()
          robotGoOut(3000)

          // Видаляємо інтервал після виконання функції
          clearInterval(interval);
        }
      }, 100); // Перевірка кожні 100 мс

      if (playerStore.isBlankInPlayer) {
        playerStore.setActiveSubmits([
          "Press '1' to get github link",
          "Press '2' to get linkedin link",
          "Press '3' to return the completed form",
          "Press '4' to exit",
        ])
      } else {
        playerStore.setActiveSubmits([
          "Press '1' to get github link",
          "Press '2' to get linkedin link",
          "Press '3' to contact form",
          "Press '4' to exit",
        ])
      }

      const handleKeyPress = (event) => {
        if (event.key >= 1 && event.key <= 4) {

          // Викликаємо функцію залежно від натиснутої кнопки
          if (event.key === "1") {
            navigator.clipboard.writeText("https://www.linkedin.com/in/andrian-martsinkovskiy-703700266")
            toast("Link successfully copied")
          }

          if (event.key === "2") {
            navigator.clipboard.writeText("https://github.com/andrianmartsinkovskiy")
            toast("Link successfully copied")
          }

          if (event.key === "3") {
            clearInterval(interval);

            if (playerStore.isBlankInPlayer) {
              formSuccessVoice.currentTime = 0
              formSuccessVoice.play()
              robotGoOut(7500)
              playerStore.clearForm()
            } else {
              playerStore.showBlank()
              formVoice.currentTime = 0
              formVoice.play()
              robotGoOut(6500)
            }

          }

          if (event.key === "4") {
            clearInterval(interval);
            buyVoice.currentTime = 0
            buyVoice.play()
            robotGoOut(3000)
          }
        }
      }

      keyPressListenerRef.current = handleKeyPress
      window.addEventListener("keydown", handleKeyPress)
    }

    const robotScale = playerStore.isRobotActive ? [1, 1, 1] : [0, 0, 0]

    return (
      <>
        {
          !playerStore.isInForm && (
            <PointerLockControls enabled={!playerStore.isInForm} ref={pointerLockRef} />
          )
        }

        {
          playerStore.isBlankVisible && (
            <group
              onPointerOver={() => {
                if (!checkDistance([-0.92,1.4,-0])) return
                playerStore.setActiveNote("get blank")
              }}
              onPointerOut={() => {
                playerStore.clearActiveNote()
              }}
              onClick={() => {
                if (!checkDistance([-0.92,1.4,-0])) return
                playerStore.clearActiveNote()
                playerStore.hideBlank()
                playerStore.changeIsBlankInPlayer(true)
              }}
            >
              <primitive object={model.nodes["blank"]} />
            </group>
          )
        }

        <group
          ref={bellRef}
          onPointerOver={() => {
            if (!checkDistance([-0.92,1.4,-0.97])) return
            if (playerStore.isRobotActive) return
            playerStore.setActiveNote("call")
          }}
          onPointerOut={() => {
            playerStore.clearActiveNote()
          }}
          onClick={startRobotAnimation}
        >
          <primitive object={model.nodes["reception_bell"]} />
        </group>

        <primitive scale={robotScale} object={model.nodes["robot"]} />
      </>
    )
  },
)


export { StartRobot }
